import { updateSettings } from "../base/settings/actions";
import { NOTIFICATION_TIMEOUT_TYPE, showNotification } from "../notifications";
const getState = (state) => state['features/moderation-command'];
export const getModCommands = (state) => getState(state)?.commandHistory;
export const getModCommand = (state, command) => {
    if (getState(state).commandHistory !== undefined) {
        return getState(state).commandHistory[command];
    }
    else {
        return null;
    }
};
export const debounce = (func, delay) => {
    let timer = null;
    return function (...args) {
        if (timer)
            clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), delay);
    };
};
export const sendChangeName = debounce((objValue) => {
    APP.store.dispatch(updateSettings({ displayName: objValue?.newName }));
    APP.store.dispatch(showNotification({
        titleKey: 'notify.changeName',
        descriptionKey: objValue?.newName
    }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
}, 300);
